import Joi from 'joi';
import { IntlFormatters } from 'react-intl';
import { URLRegEx, clientIDRegEx } from '@marketplace/common';

export const techDetailsFormValidationSchema = ({
  formatMessage,
}: Pick<IntlFormatters, 'formatMessage'>) => {
  const jwks=formatMessage({
    id:'technicalDetailsForm_confidential_secret_Jwkskey'
  });

  return Joi.object({
    sandbox: Joi.object().keys({
      client_id: Joi.optional().allow(''),
      redirect_uri_sandbox: Joi.optional().allow(''),
      smart_launch_url_sandbox: Joi.optional().allow(''),
    }),
    production: Joi.object().keys({
      client_id: Joi.string().allow(''),
      redirect_uri_production: Joi.string()
        .trim()
        .allow('')
        .pattern(URLRegEx)
        .max(2048)
        .messages({
          'string.pattern.base': formatMessage(
            { id: 'generalForm_validation_uri' },
            { field: "Redirect URI" }
          ),
          'string.max': formatMessage(
            { id: 'generalForm_validation_range_for_URL' },
            { field: "Redirect URI", max: 2048 }
          )
        }),
      smart_launch_url_production: Joi.string()
        .trim()
        .pattern(URLRegEx)
        .allow('')
        .max(2048)
        .messages({
          'string.pattern.base': formatMessage(
            { id: 'generalForm_validation_uri' },
            { field: "Smart Launch URL" }
          ),
          'string.max': formatMessage(
            { id: 'generalForm_validation_range_for_URL' },
            { field: "Smart Launch URL",max: 2048 }
          )
        }),
    }),
    application_launch_type: Joi.optional(),
    has_patient_context: Joi.optional(),
    has_encounter_context: Joi.optional(),
    token_introspection: Joi.optional(),
    scopes: Joi.optional(),
    tenants: Joi.optional(),
    jwks:Joi.string()
    .trim()
    .pattern(URLRegEx)
    .allow('')
    .messages({
      'string.pattern.base': formatMessage(
        { id: 'generalForm_validation_uri' },
        { field: jwks }
      ),
      'string.max': formatMessage(
        { id: 'generalForm_validation_range' },
        { field: jwks, min: 1, max: 2000 }
      ),
    }),
    oauthclientmechanism:Joi.optional(),
    client_secret:Joi.optional(),
    oauthclienttype:Joi.optional(),
    scope_read_all:Joi.optional(),
    //tenant_list:Joi.optional()
    production_toggle:Joi.optional(),
    status:Joi.optional(),
    secret_expiry_date: Joi.optional(),
    has_patient_individual: Joi.optional(),
    has_patient_population: Joi.optional(),
    smart_version: Joi.optional(),
  });
};
